import React from 'react';
import { FaStar } from 'react-icons/fa';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

const Testimonials = () => {
  const testimonials = [
    {
      name: 'أحمد علي',
      position: 'صانع محتوى',
      company: 'تيك توك مصر',
      image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150',
      text: 'بعد ما اشتغلت مع S.STATE، حساباتي اتحولت تماماً. التزامهم بالاستراتيجية والاهتمام بالتفاصيل خلى الفرق واضح في النتائج. أحسن وكالة اشتغلت معاها.',
      rating: 5
    },
    {
      name: 'منى سعيد',
      position: 'مؤثرة',
      company: 'انستجرام',
      image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150',
      text: 'فريق محترف جداً وبيفهموا السوق المصري كويس. ساعدوني أزيد متابعيني وأحسن محتوايا. شكراً S.STATE!',
      rating: 5
    },
    {
      name: 'خالد الزعابي',
      position: 'صانع محتوى',
      company: 'تيك توك الإمارات',
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150',
      text: 'وكالة تفهم في التيك توك. ساعدوني أطلع محتوى يناسب الجمهور الإماراتي والخليجي. متعاونين ومحترفين جداً.',
      rating: 5
    },
    {
      name: 'سارة محمد',
      position: 'مؤثرة',
      company: 'تيك توك السعودية',
      image: 'https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?w=150',
      text: 'S.STATE غيروا نظرتي للتسويق على التيك توك! استراتيجياتهم مذهلة والنتائج فاقت توقعاتي.',
      rating: 5
    },
    {
      name: 'يوسف العلي',
      position: 'صانع محتوى',
      company: 'سناب شات',
      image: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=150',
      text: 'احترافية في الشغل، والتزام بالمواعيد، وفريق خلوق. أنصح بالتعامل معاهم.',
      rating: 5
    },
    {
      name: 'لينا حسين',
      position: 'مديرة تسويق',
      company: 'علامة تجارية',
      image: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=150',
      text: 'من أفضل الوكالات اللي اشتغلت معاها. يفهموا السوق المحلي والعالمي بنفس الكفاءة.',
      rating: 5
    }
  ];

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      slidesToSlide: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 640 },
      items: 2,
      slidesToSlide: 2
    },
    mobile: {
      breakpoint: { max: 640, min: 0 },
      items: 1,
      slidesToSlide: 1
    }
  };

  return (
    <section id="testimonials" className="py-5 bg-light">
      <div className="container">
        <div className="text-center mb-5">
          <span className="badge bg-tiktok-cyan text-black px-3 py-2 mb-3">TESTIMONIALS</span>
          <h2 className="display-5 fw-bold mb-3">بيقولوا عنا</h2>
          <p className="lead text-secondary">ناس وثقوا فينا وحققوا النجاح</p>
        </div>

        <Carousel
          responsive={responsive}
          autoPlay={true}
          autoPlaySpeed={5000}
          infinite={true}
          arrows={false}
          showDots={false}
          containerClass="carousel-container pb-4"
          itemClass="px-2"
        >
          {testimonials.map((testimonial, index) => (
            <div key={index} className="h-100">
              <div className="card h-100 border-0 shadow-sm">
                <div className="card-body p-4">
                  {/* النجوم صفراء كما طلبت */}
                  <div className="text-warning mb-3">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <FaStar key={i} className="me-1" />
                    ))}
                  </div>
                  <p className="card-text mb-4">"{testimonial.text}"</p>
                  <div className="d-flex align-items-center">
                    <img 
                      src={testimonial.image} 
                      alt={testimonial.name} 
                      className="rounded-circle me-3"
                      width="60"
                      height="60"
                      style={{ objectFit: 'cover' }}
                    />
                    <div>
                      <h6 className="fw-bold mb-1">{testimonial.name}</h6>
                      <p className="small text-secondary mb-0">
                        {testimonial.position} - {testimonial.company}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Carousel>
      </div>
    </section>
  );
};

export default Testimonials;